import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiInstagram, FiTwitter, FiMail, FiArrowRight } = FiIcons;

export default function Footer() {
  return (
    <footer className="bg-smoke-light border-t border-white/5 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          
          <div className="md:col-span-2">
            <h3 className="font-serif text-2xl text-linen mb-4">Join the Library</h3>
            <p className="text-linen-dark mb-6 max-w-md text-sm leading-relaxed">
              Subscribe to receive updates on new seasonal fragrances, exclusive early access to gift sets, and musings on the art of atmosphere.
            </p>
            <form className="flex border-b border-linen/20 pb-2 max-w-md focus-within:border-ember transition-colors">
              <input 
                type="email" 
                placeholder="Your email address" 
                className="bg-transparent border-none outline-none text-linen w-full placeholder:text-linen/30 text-sm"
              />
              <button type="button" className="text-linen hover:text-ember transition-colors">
                <SafeIcon icon={FiArrowRight} />
              </button>
            </form>
          </div>

          <div>
            <h4 className="font-serif text-lg text-linen mb-6">Explore</h4>
            <ul className="space-y-3 text-sm text-linen-dark">
              <li><Link to="/shop" className="hover:text-ember transition-colors">All Fragrances</Link></li>
              <li><Link to="/shop?category=gifts" className="hover:text-ember transition-colors">Gift Sets</Link></li>
              <li><Link to="/about" className="hover:text-ember transition-colors">Our Story</Link></li>
              <li><Link to="/care" className="hover:text-ember transition-colors">Burn Guide</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-lg text-linen mb-6">Support</h4>
            <ul className="space-y-3 text-sm text-linen-dark">
              <li><Link to="/care" className="hover:text-ember transition-colors">FAQ</Link></li>
              <li><Link to="/care" className="hover:text-ember transition-colors">Shipping & Returns</Link></li>
              <li><a href="mailto:hello@embervale.com" className="hover:text-ember transition-colors">Contact Us</a></li>
              <li><span className="text-linen/30 cursor-not-allowed">Wholesale</span></li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-white/5 text-xs text-linen/40">
          <div className="flex space-x-6 mb-4 md:mb-0">
            <a href="#" className="hover:text-ember transition-colors"><SafeIcon icon={FiInstagram} className="w-5 h-5" /></a>
            <a href="#" className="hover:text-ember transition-colors"><SafeIcon icon={FiTwitter} className="w-5 h-5" /></a>
            <a href="#" className="hover:text-ember transition-colors"><SafeIcon icon={FiMail} className="w-5 h-5" /></a>
          </div>
          <div className="text-center md:text-right space-y-2">
            <p>&copy; {new Date().getFullYear()} EmberVale Candles. All rights reserved.</p>
            <p className="text-linen/60 font-medium tracking-wide" style={{ textTransform: 'none' }}><span>Made by </span><a href="https://diglab.ai/" target="_blank" rel="noopener noreferrer" className="hover:text-ember transition-colors" style={{ textTransform: 'none' }}>DigLab.ai</a><span> and </span><a href="https://linglinkai.cn/" target="_blank" rel="noopener noreferrer" className="hover:text-ember transition-colors" style={{ textTransform: 'none' }}>LingLinkAI.cn</a></p>
          </div>
        </div>
      </div>
    </footer>
  );
}